import { Progress, Typography } from 'antd'
// @ts-ignore
import useMethods from 'use-methods'
import * as React from 'react'

import { TodoItemList, TodoList } from './'
import { EditableLabel } from '../editable-label'
import { CheckSquareIcon } from '../icons'

import * as styles from './Todo.module.less'

const { Text } = Typography

export interface TodoProps {
    id: string
    todoItemList?: TodoItemList
    title: any
    // | { id: string; text: string }
    // | { id: string; text: string; type: number }
}

interface InitialState {
    id: string
    todoItemList?: TodoItemList
    title: any // React.ReactNode
}

export const Todo: React.FC<TodoProps> = (props) => {
    const handleTodoTitleSave = (value: string) => {
        console.log(value)
    }

    const initialState: InitialState = {
        id: props.id,
        todoItemList: props.todoItemList || [],
        title: (
            <Text strong>
                <CheckSquareIcon />{' '}
                <EditableLabel
                    canEdit={true}
                    editOnClick={true}
                    htmlTag="span"
                    initialValue={props.title?.text || 'todo'}
                    onSave={handleTodoTitleSave}
                    setCursorOnFocus={'selectAll'}
                />
            </Text>
        )
    }

    const [
        { id, title, todoItemList }, // <- latest state
        { addTodoItem, deleteTodoItem, renameTodoItem, toggleTodo } // <- callbacks for modifying state
    ] = useMethods(methods, initialState)

    const header = (
        <div>
            {title}
            <Progress
                percent={Math.round(
                    // @ts-ignore
                    (todoItemList?.filter((i: any) => i.isCompleted).length /
                        // @ts-ignore
                        todoItemList.length) *
                        100
                )}
            />
        </div>
    )

    return (
        <div className={styles.todo} id={id}>
            <TodoList
                header={header}
                addTodoItem={addTodoItem}
                deleteTodoItem={deleteTodoItem}
                // @ts-ignore
                todoItemList={todoItemList}
                toggleTodo={toggleTodo}
                renameTodoItem={renameTodoItem}
            />
        </div>
    )
}

const methods = (state: TodoProps) => {
    return {
        addTodoItem(title: string) {
            state.todoItemList?.push({
                createdOn: Date.now().toString(),
                id: Date.now().toString(),
                isCompleted: false,
                title
            })
        },
        deleteTodoItem(id: string) {
            state.todoItemList?.splice(
                state.todoItemList.findIndex((i) => i.id === id),
                1
            )
        },
        renameTodoItem(id: string, title: string) {
            const todo = state?.todoItemList?.find((item) => item.id === id)
            if (todo) {
                todo.title = title
            }
        },
        renameTodoList() {},
        toggleTodo(id: string) {
            const todo = state?.todoItemList?.find((item) => item.id === id)
            if (todo) {
                todo.isCompleted = !todo?.isCompleted
            }
        }
    }
}
